import { API, Auth, graphqlOperation } from "aws-amplify";
import { Card, CardSkeletonArray } from "../../_components/Card";
import { useEffect, useState } from "react";
import Lottie from "lottie-react";
import { useLocation } from "react-router-dom";
import favoriteAnimation from "../../../../lottie/6531-favorite-icon.json";

export default function FavoriteTenders() {
    const [aiPhases, setAiPhases] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const { search } = useLocation();
    const urlParams = new URLSearchParams(search);
    const urlPublication = urlParams.get("publication");
    const urlInternationalPublication = urlParams.get("internationalPublication");
    const urlType = urlParams.get("type");
    const urlKeyword = urlParams.get("keyword");
    const urlSort = urlParams.get("sort");
    const [favorites, setFavoriteTendersIDs] = useState<any[]>([]);
    const [firstRender, setFirstRender] = useState(true);
    const [loadingKeyword, setLoadingKeyword] = useState(false);
    const [companyID, setCompanyID] = useState<string>("");
    const [filteredAiPhases, setFilteredAiPhases] = useState<any[]>([]);
    const [publication, setPublication] = useState<string>(
        urlPublication ? urlPublication : ""
    );
    const [internationalPublication, setInternationalPublication] = useState<string>(
        urlInternationalPublication ? urlInternationalPublication : ""
    );
    const [country, setCountry] = useState<string>("NL");
    const [type, setType] = useState<string>(urlType ? urlType : "");
    const [keyword, setKeyword] = useState<string>(
        urlKeyword ? urlKeyword : ""
    );
    const [sort, setSort] = useState<string>(urlSort ? urlSort : "desc");

    useEffect(() => {

        let filtered = aiPhases;
        if (keyword !== "") {
            filtered = filtered.filter((item: any) =>
                item.tender.description.toLowerCase().includes(keyword.toLowerCase()));
        }
        if (publication !== "") {
            filtered = filtered.filter((item: any) => item.tender.current_phase === publication);
        }
        if (internationalPublication !== "") {
            filtered = filtered.filter((item: any) => item.tender.current_phase === internationalPublication);
        }
        if (type !== "") {
            filtered = filtered.filter((item: any) => item.tender.tender_type === type);
        }
        if (country !== "") {
            filtered = filtered.filter((item: any) => item.tender.country === country);
        }
        setFilteredAiPhases(filtered);


        //prettier-ignore
        window.history.replaceState(null, "", `?${publication !== "" ? `publication=${publication}&` : ""}${internationalPublication !== "" ? `internationalPublication=${internationalPublication}&` : ""}${country !== "" ? `country=${country}&` : ""}${type !== "" ? `type=${type}&` : ""}${sort !== "" ? `sort=${sort}&` : ""}${keyword !== "" ? `keyword=${keyword}&` : ""}`);
        if (firstRender) {
            fetchRelevantTenders("");
            setFirstRender(false);
        } else {
            setLoadingKeyword(true);
            const delayDebounceFn = setTimeout(() => {
                fetchRelevantTenders("");
                setLoadingKeyword(false);
            }, 1000);

            return () => clearTimeout(delayDebounceFn);
        }
    }, [publication, internationalPublication, type, keyword, sort, country]);

    async function fetchRelevantTenders(token: string) {
        const { attributes } = await Auth.currentAuthenticatedUser({
            bypassCache: true,
        });

        //prettier-ignore
        const TenderQuery = `query MyQuery { getUser(id: "${attributes.sub}") { companies { items { company { id saved_tenders { items { tender { title procedure dispatch_notice_date description current_phase contracting_authority tender_type id phases { items { id cpv_list description date_receipt time_receipt } } } } } } } } } }`;

        try {
            const tenderData: any = await API.graphql(
                graphqlOperation(TenderQuery)
            );

            //Favorites
            let favoriteTenders =
                tenderData.data.getUser.companies.items[0].company.saved_tenders
                    .items;

            setAiPhases(favoriteTenders);
            setFavoriteTendersIDs(favoriteTenders.map((item: any) => item.tender.id));
            setFavoriteTendersIDs(favoriteTenders.map((item: any) => item.tender.id));
            setCompanyID(tenderData.data.getUser.companies.items[0].company.id);

            // ---------------------------------------------------------------------------
            setLoading(false);
        } catch (tenderData: any) {
            //Favorites
            const favoriteTenders =
                tenderData.data.getUser.companies.items[0].company.saved_tenders
                    .items;
                    

            setAiPhases(favoriteTenders);
            setFavoriteTendersIDs(favoriteTenders.map((item: any) => item.tender.id));
            setCompanyID(tenderData.data.getUser.companies.items[0].company.id);

            setLoading(false);
        }
    }

    return (
        <section className="h-full w-full flex flex-col overflow-y-hidden overflow-x-hidden">
            {loading ? (
                <div className="w-full overflow-y-auto overflow-x-hidden h-full">
                    <CardSkeletonArray count={5} />
                </div>
            ) : aiPhases.length > 0 ? (
                <div className="flex-col w-full overflow-y-auto h-full">
                    {aiPhases.map((item: any, index: any) => (
                        <div key={index}>
                            <Card
                                item={{
                                    id: item.tender.id,
                                    title: item.tender.title,
                                    title_eng: item.tender.title,
                                    dispatch_notice_date: item.tender.dispatch_notice_date,
                                    phase: item.tender.current_phase,
                                    country: item.tender.country || "",
                                    date_receipt: item.tender.date_receipt || "",
                                    time_receipt: item.tender.time_receipt || "",
                                    description: item.tender.description || "",
                                    procedure: item.tender.procedure || "",
                                    contracting_authority: item.tender.contracting_authority || "",
                                    tender_type: item.tender.tender_type || "",
                                    tender_id: item.tender.id,
                                    contacts: item.tender.contacts || {},
                                    end_date: item.tender.end_date || ""
                                }}
                                companyID={companyID}
                                showFavoriteIcon={true}
                                favorite={true}
                            />
                        </div>
                    ))}
                </div>
            ) : (
                <div className="flex flex-col items-center pt-10 w-full mt-5 h-full">
                    <Lottie
                        className="w-[400px]"
                        loop={false}
                        animationData={favoriteAnimation}
                    />
                    <div className="group relative flex h-full justify-center w-[600px]">
                        <p className="text-xs opacity-50 pb-1 text-center cursor-pointer hover:text-primary-pink">
                            Mijn Favorieten
                        </p>
                    </div>
                    <p className="col-span-2 text-center px-5 font-bold">
                        Verzamel en zie jouw favoriete aanbestedingen.
                    </p>
                    <p className="col-span-2 text-center px-5 text-sm w-[50%] opacity-80 font-lighter">
                        Klik op het grijze hartje wat op elke aanbestedingskaart
                        beschikbaar is om deze favoriet te maken. Al je
                        favoriete aanbestedingen zullen hier vertoont worden.
                    </p>
                </div>
            )}
        </section>
    );
}